const API_BASE = "https://tansmartx-api-446662168422.asia-southeast1.run.app";

export async function fetchAiAssistant(projectId, question, granularity = "daily") {
  const res = await fetch(
    `${API_BASE}/api/gcp/ai-assistant?projectId=${encodeURIComponent(projectId)}&question=${encodeURIComponent(question)}&granularity=${encodeURIComponent(granularity)}`
  );

  if (!res.ok) {
    throw new Error("Failed AI assistant request");
  }

  return res.json();
}